import { Injectable } from '@angular/core';
import { MessageService } from '@nimbus-assistant/services/message.service';
import { LoggingSink, LogSeverity } from '../models/logging-sink';

@Injectable({
  providedIn: 'root',
})
export class FileLoggingSink implements LoggingSink {
  public log(severity: LogSeverity, timestamp: string, message: string): void {
    MessageService.SendLoggingMessage(severity.toString(), timestamp, message);
  }
}
